
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";
import { Converter } from "@/containers/Converter";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { CTASection } from "@/sections/CTASection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { ConversionSection } from "@/sections/ConversionSection";
import { VideoSection } from "@/sections/VideoSection";

const SketchToAi = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/SketchToAI"
        ogImage="/images/sketch2ai-og-image.jpg"
      />

      <MagicianSection
        title={t("page/SketchToAI:title")}
        subtitle={t("page/SketchToAI:subtitle")}
        magicianLogoFile="ai"
        cta={{
          title: t("section/magicians:seeHowItWorks"),
          scrollToId: "ApiTeaserSection",
        }}
      >
        <Converter />
      </MagicianSection>

      <TrustedBySection />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/SketchToAI:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/sketch-to-ai-example.png",
          alt: "Sketch to Adobe Illustrator converter example",
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.start") }),
        }}
        elements={t(
          "page/SketchToAI:section/apiTeaser.apiTeaserElements",
          null,
          {
            returnObjects: true,
          },
        )}
      />
      <VideoSection
        title={t("page/SketchToAI:section/videoSection.title")}
        subtitle={
          ((
            <Trans
              i18nKey="page/SketchToAI:section/videoSection.subtitle"
              components={[
                <p key="0" />,
                <p key="1" style={{ paddingTop: 20 }} />,
              ]}
            />
          ) as unknown) as string
        }
        media={{
          type: "PHOTO",
          title: "Upload demo",
          src: "/images/figma-to-illustrator-converted-file-elements.jpg",
        }}
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.start") }),
          scrollToId: "upload",
        }}
      />

      <ConversionSection
        title={t("section/conversion:title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t("section/conversion:badges.supportsGroupLayers"),
          },
          {
            iconType: "SYNC-ICON",
            text: t("section/conversion:badges.convertsComponentsSymbols"),
          },
          {
            iconType: "TV",
            text: t("section/conversion:badges.artboardStyleSupport"),
          },
        ]}
        elements={{
          from: {
            iconType: "SKETCH",
            image: "/images/sketch-ai-preview.jpg",
            title: "Sketch Demo Preview",
          },
          to: {
            iconType: "AI",
            image: "/images/illustrator-preview.jpg",
            title: "Adobe Illustrator Demo Preview",
          },
        }}
      />

      <SelectFormatSection title={t("section/selectFormat:title")} />

      <CTASection
        title={t("section/cta:titles.sketchToAiPage")}
        href="#upload"
      />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default SketchToAi;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/sketch-to-ai',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  